module.exports = __webpack_public_path__ + "img/20190810114920729.9fbee8e9.png";